import {
  initialState,
  Actions,
  State,
  GET_POSTS_TO_REORDER,
  UPDATE_GET_POSTS_TO_REORDER,
  GET_POSTS_TO_REORDER_SUCCESS,
  GET_POSTS_TO_REORDER_ERROR,
  RESET_GET_POSTS_TO_REORDER,
} from "../../types/post/get-posts-to-reorder";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_POSTS_TO_REORDER:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_POSTS_TO_REORDER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_POSTS_TO_REORDER_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case UPDATE_GET_POSTS_TO_REORDER:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      };
    case RESET_GET_POSTS_TO_REORDER:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
